import React from 'react';

const Dashboard = () => (
  <div>
    <h2>Dashboard</h2>
    <p>Welcome to the SOW App!</p>
  </div>
);

export default Dashboard;